import IMask from 'imask';
class Btn_oneClick {
	constructor() {
		this.selectors = {
			document: document,
			one_click_toggle: '#js-btn-one-click',
			oneclick_form: '#js-one-click-form'
		};
		this.init();
		this.events();
	};
	init() {
		this.getNodes();
	}

	getNodes() {
		var _this = this;
		this.nodes = {};
		$.each(this.selectors, function(key, selector) {
			_this.nodes[key] = $(selector);
		});
	}

	events() {
		// Delete unnecessary on-click-btn
		$(document).ready(() => {
			if ( 
				$('#js-mobile-one-click').length && $(window).width() > 575 
				) $('#js-mobile-one-click').remove();
			if ( 
				$('#js-desktop-one-click').length && $(window).width() <= 575 
				) $('#js-desktop-one-click').remove();
		});
		// Product button opens one-click-popup
		this.nodes.document.on('click', this.selectors.one_click_toggle, e => {
			const $product = $(e.currentTarget);
			templateOneClick($product);			
		})

		//Template One Click Popup
		function templateOneClick(item){
			$.magnificPopup.open({
				type : 'inline',
				callbacks: {
					open: function() {
						$('#js-name-val').keypress(event => (event.key).match(/^[A-Za-zȘȚÎĂÂșțăîâа-яА-ЯёЁ\s]+$/) ? true : false);
						$('#js-phone-val').keypress(event => (event.key).match(/^[+()\d-]+$/) ? true : false);						
						$('#js-comment-val').keypress(event => (event.key).match(/^[A-Za-zȘȚÎĂÂșțăîâа-яА-ЯёЁ0-9.,\s]+$/) ? true : false);
						let bindElements = ['#js-comment-val', '#js-phone-val', '#js-name-val'];						
						bindElements.map(element => $(element).bind('copy paste cut', e => e.preventDefault()));						

						if ($('#js-btn-one-click').data('mask')) {
							$('#js-phone-val').on('focus', () => {
								const mask = $('#js-phone-val').data( 'mask' ) || null
								if (!$('#js-phone-error')[0].classList.contains('d-none')) $('#js-phone-error')[0].classList.add('d-none');
								
								if ( !mask ) {
									$('#js-phone-val').data( 'mask', new IMask( $('#js-phone-val').get( 0 ), {
										mask: '{+373}`00 000 000',									
										lazy: false,
										placeholderChar: '*',									
									}) );							
								}				
							});

							$('#js-phone-val').on('blur',() => {
								const value = $('#js-phone-val').val().replace(/[^0-9.]/g,'');			
								if ( value == '373' ){								
									$('#js-phone-val').data( 'mask', null );
									$('#js-phone-val').val( '' );
								}						
							});						
						}


						if ($('#js-btn-one-click').attr('data-captcha-key')) {							
							$('#js-btn-block-form-main')
								.prepend(
									'<div id="captcha_container" class="g-recaptcha" data-callback="onloadCallback"></div>'
								);
							setTimeout(function() {
								grecaptcha.render('captcha_container', {
									'sitekey': `${item.data('captcha-key')}`
								});
							}, 500);
						}
					}
				},
				items: {
					src :`<div id="one-click-popup" class="send_message_one_click">
							<div class="wrap_titleoneclick">
								<span>${item.data('popup-title')}</span>
							</div>
							<form id="js-one-click-form" class="send_message_one_click_form" method="post" 
								action="${item.data('form-action')}">
								<input type="hidden" name="product_id" value="${item.data('product-id')}">
								<input class="form-control" type="hidden" name="client_id" value="${item.data('client-id')}">
								<div class="wrap_nameoneclick">
									<input class="form-control" id="js-name-val" placeholder="${item.data('input-name')}"  name="customer_name" required>
								</div>
								<div class="wrap_phoneoneclick">
									<input class="form-control" id="js-phone-val" placeholder="${item.data('input-phone')}" 
										type="tel"  name="customer_phone" 
										oninvalid="this.setCustomValidity('${item.data('input-customvalidity')}')" required>
									<span id="js-phone-error" class="phone-error d-none">${item.data('phone-error')}</span>
								</div>
								<div class="wrap_areaoneclick">
									<textarea id="js-comment-val" placeholder="${item.data('input-comment')}" 
										class="form-control" rows="4" name="comment"></textarea>
								</div>
								<div class="wrap_one_click_form_submit ${item.data('captcha-key') ? 'captcha' : ''}" id="js-btn-block-form-main">
									<button type="submit" id="one-click-form-submit-main" ${item.data('captcha-key') ? 'disabled' : '' }>
										${item.data('button-text')}
									</button>
								</div>
								<div class="success_one_click_main text-center d-none">
									<h4>${item.data('success-msg')}</h4>
								</div>
							</form>
						</div>`
				}
			})
		}	
		
		// Post request after confirm		
		$(document).on('submit', '#js-one-click-form', e => {
			e.preventDefault();
			const $this = $(e.currentTarget);
			const data  = $this.serialize();
			const phoneValue = $('#js-phone-val').val();
			let enableSubmit = false;

			const sendData = () => {
				$.post($this.attr('action'), data, function(resp){
					if(resp.success){
						$('.wrap_titleoneclick').css('border', 'none');
						$('.wrap_nameoneclick').hide();
						$('.wrap_phoneoneclick').hide();
						$('.wrap_areaoneclick').hide();					
						$('#js-btn-block-form-main').hide();
						$('.success_one_click_main').removeClass('d-none')
						setTimeout(() => {
							$.magnificPopup.close()
						}, 4000)
					}
				});
			}

			if ($('#js-btn-one-click').data('mask')) {
				if (phoneValue[4] !== '0' && phoneValue.charAt(phoneValue.length - 1) !== '*') enableSubmit = true;

				if (!enableSubmit && $('#js-phone-error')[0].classList.contains('d-none')) $('#js-phone-error')[0].classList.remove('d-none');					
				
				if (enableSubmit && $('#js-phone-error')[0].classList.contains('d-none')) sendData();	
			}

			if (!$('#js-btn-one-click').data('mask')) sendData();			
		});		
	}
}
new Btn_oneClick();
